import {useState} from 'react';
import DBModal from "../../../../../component/global/DBModal";
import BackButton from "../../../../../component/global/BackButton";
import {ReactComponent as Person} from './../../../../../asset/icons/userIcon.svg'
import {Tab, Tabs} from "react-bootstrap";
import TransactionRecords from "./TransactionRecords";
import PackagesRecords from "./PackagesRecords";
import Receipt from "./Receipt";
import {useTranslation} from "react-i18next";

function PackagesReportModal(props) {
  const {onHide, show} = props
  const {t} = useTranslation()
  const [activeTab, setActiveTab] = useState('1')

  return (
    <DBModal
      minWidth={300}
      show={show}
      onHide={onHide}
      className="packages-report-modal"
    >
      <DBModal.Content>
        <div className='header-modal'>
          <div className='logo'>
            <Person/>
            <span>{t('Organizational.Profile.Packages.Report.Title')}</span>
          </div>
          <BackButton onclickFunction={onHide}/>
        </div>
        <div className="content-modal">
          <div className='tab-section'>
            <Tabs
              activeKey={activeTab}
              transition={false}
              className="panel_tab"
              onSelect={(tab) => setActiveTab(tab)}
            >
              <Tab
                eventKey="1"
                className="panel_tab_item"
                title={t('Organizational.Profile.Packages.Report.Transaction.Records.Tab')}
              />
              <Tab
                eventKey="2"
                className="panel_tab_item"
                title={t('Organizational.Profile.Packages.Report.Packages.Records.Tab')}
              />
              <Tab
                eventKey="3"
                className="panel_tab_item"
                title={t('Organizational.Profile.Packages.Report.Receipt.Tab')}
              />
            </Tabs>
          </div>
          <div className="content-section">
            {activeTab === "1" && <TransactionRecords/>}
            {activeTab === "2" && <PackagesRecords/>}
            {activeTab === "3" && <Receipt/>}
          </div>
        </div>
      </DBModal.Content>
    </DBModal>
  );
}

export default PackagesReportModal;
